import styled from "styled-components";
import { defaultTheme } from "storybook/themes/default";

const { colors } = defaultTheme;

export const StyledInputContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export const StyledInput = styled.input<{
  $error?: boolean;
  $disabled?: boolean;
  $isDirty?: boolean;
}>`
  width: 100%;
  border: 0;
  margin: 0;
  display: block;
  min-width: 0;
  background: none;
  box-sizing: border-box;
  font-size: 16px;
  font-weight: 700;
  font-variation-settings: "wght" 700;
  height: 37px;
  border-radius: 8px;
  padding: 0.5rem 1rem;
  text-align: right;
  font-family: ${defaultTheme.typography.fontFamily};
  color: ${({ $error, $isDirty }) =>
    $error ? colors.error : $isDirty ? colors.dirtyLabel : colors.black};
  cursor: ${({ $disabled }) => ($disabled ? "not-allowed" : "text")};
  border: 1px solid
    ${({ $error }) => ($error ? colors.error : colors.inputBorder)};

  &:hover {
    border-color: ${({ $error, $disabled }) => {
      if ($disabled) return "auto";
      return $error ? colors.error : colors.defaultTextButton;
    }};
  }

  &:focus {
    outline: none;
    border: 2px solid
      ${({ $error }) => ($error ? colors.error : colors.ciqBrand)};
  }

  &::placeholder {
    color: rgba(106, 110, 135, 0.5);
    opacity: 1;
  }
`;
